import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import { Vue2Dragula } from 'vue2-dragula'
import 'dragula/dist/dragula.css'
import VueCarousel from 'vue-carousel'
import VTooltip from 'v-tooltip'

// Stylus
import './stylus/main.styl'

Vue.use(VueCarousel);

Vue.use(VTooltip)

export const eventBus = new Vue();

import Page0_1 from './pages/Page0-1.vue'
import Page1_1 from './pages/Page1-1.vue'
import Page1_2 from './pages/Page1-2.vue'
import Page1_3 from './pages/Page1-3.vue'
import Page1_4 from './pages/Page1-4.vue'
import Page1_5 from './pages/Page1-5.vue'
import Page1_6 from './pages/Page1-6.vue'
import Page1_7 from './pages/Page1-7.vue'
import Page2_1 from './pages/Page2-1.vue'
import Page3_1 from './pages/Page3-1.vue'
import Page3_2 from './pages/Page3-2.vue'
import Page3_3 from './pages/Page3-3.vue'
import Page4_1 from './pages/Page4-1.vue'
import Page4_2 from './pages/Page4-2.vue'
import Page5_1 from './pages/Page5-1.vue'
import Page6_1 from './pages/Page6-1.vue'
import Page6_2 from './pages/Page6-2.vue'
import Page6_3 from './pages/Page6-3.vue'
import Page6_4 from './pages/Page6-4.vue'
import Page6_5 from './pages/Page6-5.vue'
import Page6_6 from './pages/Page6-6.vue'
import Page6_7 from './pages/Page6-7.vue'
import Page6_8 from './pages/Page6-8.vue'
import Page6_9 from './pages/Page6-9.vue'
import Page6_10 from './pages/Page6-10.vue'
import Page6_11 from './pages/Page6-11.vue'
import Page6_12 from './pages/Page6-12.vue'
import Page6_13 from './pages/Page6-13.vue'
import Page6_14 from './pages/Page6-14.vue'
import Page6_15 from './pages/Page6-15.vue'
import Page6_16 from './pages/Page6-16.vue'
import Page6_17 from './pages/Page6-17.vue'
import Page6_18 from './pages/Page6-18.vue'
import Page6_19 from './pages/Page6-19.vue'
import Page6_20 from './pages/Page6-20.vue'
import Page7_1 from './pages/Page7-1.vue'
import Page7_2 from './pages/Page7-2.vue'
import Page8_1 from './pages/Page8-1.vue'
import Page8_2 from './pages/Page8-2.vue'
import Page8_3 from './pages/Page8-3.vue'
import Page8_4 from './pages/Page8-4.vue'
import Page9_1 from './pages/Page9-1.vue'
import Page10_1 from './pages/Page10-1.vue'
import Page10_2 from './pages/Page10-2.vue'
import Page10_3 from './pages/Page10-3.vue'
import Page10_4 from './pages/Page10-4.vue'
import Page10_5 from './pages/Page10-5.vue'
import Page10_6 from './pages/Page10-6.vue'
import Page10_7 from './pages/Page10-7.vue'


import Breadcrumb from './components/Breadcrumb.vue'
import L_Progress from './components/LessonProgress.vue'

Vue.use(Vue2Dragula, {
  logging: {
    directive: true,
    plugin: true,
    service: true,
    dragHandler: true,
    modelManager: true
  }
})

Vue.config.debug = true
// pages
Vue.component('page0-1', Page0_1);
Vue.component('page1-1', Page1_1);
Vue.component('page1-2', Page1_2);
Vue.component('page1-3', Page1_3);
Vue.component('page1-4', Page1_4);
Vue.component('page1-5', Page1_5);
Vue.component('page1-6', Page1_6);
Vue.component('page1-7', Page1_7);
Vue.component('page2-1', Page2_1);
Vue.component('page3-1', Page3_1);
Vue.component('page3-2', Page3_2);
Vue.component('page3-3', Page3_3);
Vue.component('page4-1', Page4_1);
Vue.component('page4-2', Page4_2);
Vue.component('page5-1', Page5_1);
Vue.component('page6-1', Page6_1);
Vue.component('page6-2', Page6_2);
Vue.component('page6-3', Page6_3);
Vue.component('page6-4', Page6_4);
Vue.component('page6-5', Page6_5);
Vue.component('page6-6', Page6_6);
Vue.component('page6-7', Page6_7);
Vue.component('page6-8', Page6_8);
Vue.component('page6-9', Page6_9);
Vue.component('page6-10', Page6_10);
Vue.component('page6-11', Page6_11);
Vue.component('page6-12', Page6_12);
Vue.component('page6-13', Page6_13);
Vue.component('page6-14', Page6_14);
Vue.component('page6-15', Page6_15);
Vue.component('page6-16', Page6_16);
Vue.component('page6-17', Page6_17);
Vue.component('page6-18', Page6_18);
Vue.component('page6-19', Page6_19);
Vue.component('page6-20', Page6_20);
Vue.component('page7-1', Page7_1);
Vue.component('page7-2', Page7_2);
Vue.component('page8-1', Page8_1);
Vue.component('page8-2', Page8_2);
Vue.component('page8-3', Page8_3);
Vue.component('page8-4', Page8_4);
Vue.component('page9-1', Page9_1);
Vue.component('page10-1', Page10_1);
Vue.component('page10-2', Page10_2);
Vue.component('page10-3', Page10_3);
Vue.component('page10-4', Page10_4);
Vue.component('page10-5', Page10_5);
Vue.component('page10-6', Page10_6);
Vue.component('page10-7', Page10_7);


//components
Vue.component('breadcrumb', Breadcrumb);
Vue.component('l-progress', L_Progress);

window.App = new Vue({
  el: '#app',
  render: h => h(App)
})
